<template>
<v-card :flat='flat' >
  <request-status :request='getApptReq' :message200='false' />
  <v-card-title class='overline py-1' >
    Appointment details
    <v-spacer />
    <template v-if='sharelink' >
      <v-btn @click='sharedialog=true' small icon >
        <v-icon small>share</v-icon>
      </v-btn>
      <v-dialog v-model='sharedialog' max-width='360' >
        <share-card
          :links='[sharelink]'
          :relationship-id='appointment.computed_relationship_id' />
      </v-dialog>
    </template>
  </v-card-title>

  <v-divider/>
  <v-list dense two-line subheader >
    <v-list-tile avatar >
      <v-list-tile-avatar>
        <v-icon>event</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title >Date and time</v-list-tile-title>
        <v-list-tile-sub-title >
          {{ formatFromTo(appointment.start_time, appointment.end_time) }}
        </v-list-tile-sub-title>
        <v-list-tile-sub-title v-if='appointment.client_timezone && appointment.client_timezone !== $store.getters.settings.timezone' >
          Client's timezone: {{appointment.client_timezone}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action >
        <v-btn small outline outlined color='primary'
          @click.stop='$store.dispatch("SHOW_APPOINTMENT_DIALOG", [true, "Reschedule", appointment])' >
          Reschedule
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>

    <!-- location details -->
    <template v-if='appointment.location && (appointment.location.address || appointment.location.name)' >
    <v-subheader class='overline' >Flexible location</v-subheader>
    <v-list-tile avatar >
      <v-list-tile-avatar>
        <v-icon>location_on</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-text='appointment.location.name' />
        <v-list-tile-sub-title v-text='appointment.location.formatted_address || appointment.location.address' >
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action v-if='appointment.location.url' >
        <v-btn :href='appointment.location.url' target='_blank' icon><v-icon>open_in_new</v-icon></v-btn>
      </v-list-tile-action>
      <v-list-tile-action @click='editLocation=true' >
        <v-btn icon><v-icon>edit</v-icon></v-btn>
      </v-list-tile-action>
      <v-dialog v-model='editLocation' width='340' >
        <v-form v-model='locationIsValid'
          @submit.prevent='save({location: appointment.location})' >
          <v-card>
            <request-status :request='apptReq' :message200='false' />
            <v-card-title class='subtitle-1 overline' >
              Edit this location
              <v-spacer/>
              <v-btn @click='editLocation=false' icon ><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model='appointment.location.name' label='Place of interest name' />
              <v-text-field v-model='appointment.location.address' label='Physical address' />
              <v-text-field append-icon='link' type='url' clearable
                v-model='appointment.location.url'
                label='Map address'
                placeholder='https://'
                :rules='urlRules'
                hint='Link to an address in google maps or whatever mapping software you use' />
            </v-card-text>
            <v-divider/>
            <v-card-actions >
              <v-btn @click='editLocation=false' flat >Cancel</v-btn>
              <v-spacer/>
              <v-btn type='submit'
                :disabled='!locationIsValid'
                :loading='apptReq.loading'
                color='primary' >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-list-tile>
    </template>

    <v-list-tile avatar v-else-if='appointment.address_data' >
      <v-list-tile-avatar>
        <v-icon>location_on</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title >Location</v-list-tile-title>
        <v-list-tile-sub-title >
          {{appointment.address_data.name}}. {{appointment.address_data.address}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>

    <!-- <pre v-text="appointment" /> -->

    <v-list-tile v-if='productData && productData.id' >
      <v-list-tile-avatar>
        <v-icon>star</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title >Appointment Type</v-list-tile-title>
        <v-list-tile-sub-title >
          {{ productData.title }}
          <span v-if="appointment.practitioner_name" > with {{appointment.practitioner_name}}</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action >
        <v-btn @click="changeAppointmentType=true" small flat >Change</v-btn>
      </v-list-tile-action>

      <v-dialog v-model="changeAppointmentType" width="640" >

        <v-card>
          <transfer-appointment
            v-if="changeAppointmentType"
            :appointment="appointment"
            @saved="get();changeAppointmentType=false"
            @close="changeAppointmentType=false" />
        </v-card>

      </v-dialog>
    </v-list-tile>

    <!-- clients  -->
    <div v-if='relationship && relationship.id && appointment.status && appointment.status.toLowerCase() !== "b"' >
      <v-subheader class='overline' >Customer information</v-subheader>
      <template v-if='appointment.relationships && appointment.relationships.length > 0 && isNaN(appointment.relationships[0])' >
        <client-list-item with-details with-whatsapp with-edit
          v-for='relationship in appointment.relationships'
          :key='relationship.id'
          @listitem:clicked='gotoClient(relationship.relationship)'
          :relationship-id='relationship.relationship.id'
          :client='relationship.relationship' >
          <template slot='actions' >
            <v-list-tile-action  >
              <v-btn @click.stop='launchSetAppointmentClient({value: appointment, withDependent: true })' :flat='!$vuetify.breakpoint.xs' :icon='$vuetify.breakpoint.xs' >
                <v-icon v-if='$vuetify.breakpoint.xs' >manage_accounts</v-icon>
                <span v-else >Change</span>
              </v-btn>
            </v-list-tile-action>
            <!-- <v-list-tile-action >
              <v-btn @click.stop='launchCustomerDetailsDialog(relationship.relationship.id, true)' icon >
                <v-icon>edit</v-icon>
              </v-btn>
            </v-list-tile-action> -->
            <v-list-tile-action v-if='sharelink' >
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on='on'
                    @click.stop=''
                    :href='sharelink.url'
                    target='_blank' >
                    <v-icon >open_in_new</v-icon>
                  </v-btn>
                </template>
                <span >Open client appointment page</span>
              </v-tooltip >
            </v-list-tile-action >
          </template>
        </client-list-item>
      </template>
      <client-list-item v-else
        @listitem:clicked='gotoClient(relationship)'
        :relationship-id='relationship.id'
        :client='relationship.client' >
      </client-list-item>
      <div v-if="fullName && fullName !== appointment.full_name" >
        <v-subheader class="overline" >
          Patient name: {{appointment.full_name}}
          <v-btn icon small
            @click.stop='launchSetAppointmentClient({value: appointment, withDependent: true })' >
            <v-icon small>edit</v-icon></v-btn>
        </v-subheader>
      </div>
    </div>
    <v-card flat v-else >
      <v-card-text>
        <v-list subheader three-line class='orange lighten-2 elevation-4' >
          <v-subheader class='overline' >
            Please choose a client
            <v-spacer></v-spacer>
            The client used the following information when making the appointment
          </v-subheader>
          <v-list-tile >
            <v-list-tile-avatar >
              <v-icon>warning</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-text='appointment.full_name' >
              </v-list-tile-title>
              <v-list-tile-sub-title >{{appointment.contact_email}}</v-list-tile-sub-title>
              <v-list-tile-sub-title >{{appointment.contact_phone}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action >
              <v-btn
                @click='launchSetAppointmentClient({value: appointment})'
                outline outlined >Set client</v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <template v-if='appointment && appointment.is_online' class='mt-2' >
      <online-meeting-card
        :withedit='true'
        :editmode='!appointment.zoom_meeting_id'
        :appointment='appointment' >
      </online-meeting-card>
    </template>

    <v-card v-if="codes" tile >
      <appointment-codes v-model='appointment' title='Codes' with-title :with-done='false' />
    </v-card>

  </v-list>

  <!-- <v-card v-if='appointment.location' flat>
    <v-card-title class='overline' >Location information</v-card-title>
    <v-list>
      <v-list-tile >
        <v-list-tile-action v-if='appointment.location.url' >
          <v-icon>location_on</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text='appointment.location.name' >
          </v-list-tile-title>
          <v-list-tile-sub-title v-text='appointment.location.formatted_address' >
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if='appointment.location.url' >
          <v-btn :href='appointment.location.url' target='_blank' icon><v-icon>open_in_new</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card> -->


  <v-card v-if='appointment.notes' flat >
    <v-card-title class='overline py-0 mt-4' >Appointment notes</v-card-title>
    <v-card-text>
      <pre class='blue lighten-5 pa-2 caption' >{{ appointment.notes }}</pre>
    </v-card-text>
  </v-card>

  <v-card-text class='mt-2'>
    <tag-list :appointment='appointment' :deleteable='true' ></tag-list>
  </v-card-text>
  <v-card-text v-if='appointment.recurring_appointment' >
    <recurring-appointment-form
      v-model='appointment'
      :flat='false' >
    </recurring-appointment-form>
  </v-card-text>
</v-card>
</template>
<script>
import ClientListItem from '@/components/client/ClientListItem'
import TagList from '@/components/appointment/TagList'
import RecurringAppointmentForm from '@/components/forms/RecurringAppointmentForm'
import OnlineMeetingCard from '@/components/cards/OnlineMeetingCard'
import AppointmentCodes from '@/components/appointment/AppointmentCodes.vue'
import ShareCard from '@/components/cards/ShareCard.vue'
import TransferAppointment from '@/components/actions/TransferAppointment/Index.vue'
// import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AppointmentCard',
  components: {
    ClientListItem,
    TagList,
    RecurringAppointmentForm,
    OnlineMeetingCard,
    AppointmentCodes,
    TransferAppointment,
    ShareCard
  },
  props: {
    value: { type: Object, default: () => { return {} } },
    flat: { type: Boolean, default: true },
    fetch: { type: Boolean, default: false }
  },
  data () {
    return {
      appointment: {},
      editLocation: false,
      sharedialog: false,
      apptReq: {
        resource: 'ag.appointments'
      },
      getApptReq: {
        resource: 'ag.appointments'
      },
      move: {
        practitioner: null,
        product: {id: null, title: ''}
      },
      changeAppointmentType: false,
      locationIsValid: false,
      urlRules: [
        value => {
          if (!value) { return true }
          var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
          return pattern.test(value) || 'Please enter a valid link'
        }
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    },
    apptReqStatus () {
      if (this.apptReqStatus === 200) {
        // this.appointment = this.apptReq.result
        // this.$emit('input', this.apptReq.result)
        this.editLocation = false
      }
    },
    getApptReqStatus () {
      if (this.getApptReqStatus === 200) {
        this.appointment = this.getApptReq.result
      }
    },
    appointmentId () {
      if (this.appointmentId && this.fetch) { this.get() }
    },
    practitionerId () {
      if (this.appointment) {
        return this.appointment.practitioner
      }
      return null
    }
  },
  computed: {
    ...mapGetters(['products']),
    apptReqStatus () {
      return this.apptReq.status
    },
    getApptReqStatus () {
      return this.getApptReq.status
    },
    appointmentId () {
      return this.getObjectPath(this.appointment, 'id')
    },
    practitionerId () {
      return this.getObjectPath(this.appointment, 'practitioner.id')
    },
    codes () {
      return this.getObjectPath(this.appointment, 'codes', [])
    },
    sharelink () {
      if (this.appointment && this.appointment.relationships && this.appointment.relationships.length === 1) {
        let rel = this.appointment.relationships[0]
        let path = this.getObjectPath(rel, 'get_absolute_url')
        if (path) {
          return {
            url: `https://appt.guru/${path}`,
            title: 'Appointment Page'
          }
        }
      }
      return null
    },
    relationship () {
      if (this.appointment && this.appointment.client) {
        if (this.appointment.client.id) {
          return this.appointment.client
        }
        let userId = this.appointment.client
        if (isNaN(this.appointment.client)) {
          userId = this.appointment.client.id
        }
        return this.getRelationByClientId(userId)
      }
    },
    fullName () {
      if (this.relationship && this.relationship.first_name) {
        return `${this.relationship.first_name} ${this.relationship.last_name}`
      }
      return null
    },
    productData () {
      if (this.appointment && this.appointment.product) {
        return this.getProductById(this.appointment.product)
      }
      return null
    }
  },
  methods: {
    locationMap (addr) {
      if (addr.latitude && addr.longitude) {
        let latlng = `${addr.latitude},${addr.longitude}`
        let key = 'AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY'
        let url = `https://maps.googleapis.com/maps/api/staticmap?center=${latlng}&zoom=14&size=640x180&scale=2&markers=color:blue%7C${latlng}&key=${key}`
        return url
      }
    },
    getProductById (id) {
      return this.products.find((prod) => {
        console.log(prod.id, id)
        return (this.idsAreEqual(prod.id, id))
      })
    },
    get () {
      if (this.appointmentId) {
        this.getApptReq.resourceId = this.appointmentId
        this.$request('get', this.getApptReq)
      }
    },
    save (data) {
      if (this.appointmentId) {
        this.apptReq.resourceId = this.appointmentId
        this.apptReq.data = data
        this.$request('save', this.apptReq)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentCard.vue?1c56227e